/*
 * @Author: hai.yang3 hai.yang3@gientech.com
 * @Date: 2022-08-18 17:53:06
 * @LastEditors: wangkg wangkegui@longfor.com
 * @LastEditTime: 2022-12-23 07:46:45
 * @FilePath: \unified-development-platform\src\store\modules\move-auth\organization.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { get_orgs } from '@/apis/auth/move-auth/platform/organization_api.js'
const types = {
  GET_ORGANIZATIONS: 'GET_ORGANIZATIONS'
};
const state = {
  orgs: []
};
const actions = {
  async getOrgs(context, params) {
    let res = await get_orgs(params);
    context.commit(types.GET_ORGANIZATIONS, res);
  }
};
const mutations = {
  [types.GET_ORGANIZATIONS](state, payload) {
    state.orgs = payload;
  }
};
const getters = {
  orgs: (state) => state.orgs
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
